var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33333C24.7258 3.33333 19.5701 4.8973 15.1848 7.82747C10.7995 10.7576 7.38155 14.9224 5.36321 19.7951C3.34487 24.6678 2.81679 30.0296 3.84573 35.2024C4.87466 40.3752 7.41442 45.1268 11.1438 48.8562C14.8732 52.5856 19.6248 55.1253 24.7976 56.1543C29.9704 57.1832 35.3322 56.6551 40.2049 54.6368C45.0776 52.6185 49.2424 49.2005 52.1725 44.8152C55.1027 40.4299 56.6667 35.2742 56.6667 30C56.6667 22.9276 53.8572 16.1448 48.8562 11.1438C43.8552 6.14284 37.0724 3.33333 30 3.33333ZM47.4167 21.05L25.5167 42.9333L12.5833 30C12.1413 29.558 11.893 28.9585 11.893 28.3333C11.893 27.7082 12.1413 27.1087 12.5833 26.6667C13.0254 26.2246 13.6249 25.9763 14.25 25.9763C14.8751 25.9763 15.4746 26.2246 15.9167 26.6667L25.55 36.3L44.1167 17.75C44.3355 17.5311 44.5954 17.3575 44.8813 17.2391C45.1673 17.1206 45.4738 17.0596 45.7833 17.0596C46.0929 17.0596 46.3994 17.1206 46.6853 17.2391C46.9713 17.3575 47.2311 17.5311 47.45 17.75C47.6689 17.9689 47.8425 18.2287 47.9609 18.5147C48.0794 18.8006 48.1404 19.1071 48.1404 19.4167C48.1404 19.7262 48.0794 20.0327 47.9609 20.3187C47.8425 20.6046 47.6689 20.8645 47.45 21.0833L47.4167 21.05Z",
    fill: "#07851B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessicon);
export default __webpack_public_path__ + "static/media/successicon.0d8905772856981323e8efe82c4b33b6.svg";
export { ForwardRef as ReactComponent };